module.exports = __webpack_public_path__ + "img/91cc3ac.jpeg";